<h1 mat-dialog-title>Gerar {{ isFiscalParts && isFiscalLabors ? 'notas' : 'documentos' }}</h1>

<mat-dialog-content>
  <section class="emission-cards">
    <!-- Nota de peças -->
    @if (data.emission.parts) {
    <article class="emission-card">
      <h2 class="card-title">{{ data.emission.parts.model }}</h2>

      <div class="card-status">
        @switch (data.emission.parts.status()) {
        @case ('generating') {
        <mat-spinner [diameter]="20"></mat-spinner>
        <span>Gerando...</span>
        }
        @case ('fiscal_rejection') {
        <mat-icon class="yellow">info</mat-icon>
        <span>Rejeição fiscal</span>
        }
        @case ('success') {
        <mat-icon class="green">check_circle_outline</mat-icon>
        <span>{{ isFiscalParts ? 'Emitida' : 'Criada' }} com sucesso.</span>
        }
        @default {
        <mat-icon class="red">error_outline</mat-icon>
        <span>Houve um erro.</span>
        }
        }
      </div>

      @if (data.emission.parts.status() === 'success') {
      <div class="card-actions">
        <button mat-button
                (click)="seeInvoiceOf('parts')"
                color="primary">
          {{ isFiscalParts ? 'Ver nota' : 'Ver operação' }}
        </button>

        @if(isFiscalParts) {
        <button mat-button
                color="primary"
                (click)="seeInvoicePDF('parts')">
          <mat-icon>picture_as_pdf</mat-icon>
          Ver PDF
        </button>

        <button mat-button
                color="primary"
                (click)="downloadInvoiceXML('parts')">
          <mat-icon>code</mat-icon>
          Baixar XML
        </button>
        }
      </div>
      }

      @if (data.emission.parts.statusMessage()) {
      <pre class="error-message"
           [innerHTML]="data.emission.parts.statusMessage()"></pre>
      }
    </article>
    }

    <!-- Nota de serviços -->
    @if (data.emission.labors) {
    <article class="emission-card">
      <h2 class="card-title">{{ data.emission.labors.model }}</h2>

      <div class="card-status">
        @switch (data.emission.labors.status()) {
        @case ('generating') {
        <mat-spinner [diameter]="20"></mat-spinner>
        <span>Gerando...</span>
        }
        @case ('fiscal_rejection') {
        <mat-icon class="yellow">info</mat-icon>
        <span>Rejeição fiscal</span>
        }
        @case ('success') {
        <mat-icon class="green">check_circle_outline</mat-icon>
        <span>{{ isFiscalLabors ? 'Emitida' : 'Criada' }} com sucesso.</span>
        }
        @default {
        <mat-icon class="red">error_outline</mat-icon>
        <span>Houve um erro.</span>
        }
        }
      </div>

      @if (data.emission.labors.status() === 'success') {
      <div class="card-actions">
        <button mat-button
                (click)="seeInvoiceOf('labors')"
                color="primary">
          {{ isFiscalLabors ? 'Ver nota' : 'Ver operação' }}
        </button>

        @if(isFiscalLabors){
        <button mat-button
                color="primary"
                (click)="seeInvoicePDF('labors')">
          <mat-icon>picture_as_pdf</mat-icon>
          Ver PDF
        </button>

        <button mat-button
                color="primary"
                (click)="downloadInvoiceXML('labors')">
          <mat-icon>code</mat-icon>
          Baixar XML
        </button>
        }
      </div>
      }

      @if (data.emission.labors.statusMessage()) {
      <pre class="error-message"
           [innerHTML]="data.emission.labors.statusMessage()"></pre>
      }
    </article>
    }
  </section>

  <!-- títulos -->
  @if (hasAnyTitles) {
  <article class="emission-card link titles-status">
    <h2 class="card-title">Títulos</h2>

    <div class="card-status">
      <mat-icon class="green">check_circle_outline</mat-icon>
      <span>Criados com sucesso.</span>
    </div>

    <div class="card-actions">
      @if (showMatrixTitlesButton) {
      <a mat-button
         class="line-heigth-initial"
         (click)="goToTitlesOf('matrix')">
        {{ showFilialTitlesButton ? 'Ver títulos matriz' : 'Ver títulos' }}
      </a>
      }

      @if (showFilialTitlesButton) {
      <a mat-button
         class="line-heigth-initial"
         (click)="goToTitlesOf('filial')">Ver títulos filial</a>
      }
    </div>
  </article>
  }
</mat-dialog-content>

<mat-dialog-actions [class.mobile]="layout.isHandset$ | async"
                    class="d-flex justify-content-end">
  <button mat-raised-button
          mat-dialog-close
          color="accent">
    Fechar
  </button>

  <a mat-raised-button
     class="dialog-action-white-text"
     (click)="goToCreateNewBudget()"
     color="primary">Abrir outro orçamento</a>

  <a mat-raised-button
     class="dialog-action-white-text"
     (click)="goToInvoiceList()"
     color="primary">Ir para notas</a>

  <button mat-raised-button
          *ngIf="canCreateBoleto()"
          [disabled]="creatingBoleto()"
          color="primary"
          (click)="createBoleto()">
    Gerar Boletos
  </button>

  @if (createdBoleto()) {
    <button mat-raised-button
            (click)="seeBoleto()"
            color="primary">Ver Boletos</button>
  }
</mat-dialog-actions>